<div class="signup-page">
  <div class="signup-shell">
    <!-- Left Visual Panel -->
    <div class="signup-visual">
      <div class="visual-content">
        <!-- <div class="visual-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div> -->

        <div class="visual-image">
          <img
            src="assets/images/absences_lms_login_banner.png"
            alt="Absence Assistance"
          />
        </div>

        <div class="visual-footer">
          <span>
            <i class="pi pi-shield"></i>
            Secure platform
          </span>

          <span>
            <i class="pi pi-sparkles"></i>
            Manage your learning resources
          </span>

          <span>
            <i class="pi pi-sparkles"></i>
            Access your documents anywhere
          </span>
        </div>
      </div>
    </div>

    <!-- Signup Form -->
    <div class="signup-panel">
      <div class="signup-content">
        <!-- Mobile Logo -->
        <div class="mobile-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div>

        <!-- Header -->
        <div class="signup-header">
          <!-- <span class="signup-eyebrow"> Create your account </span> -->

          <h2>Let's get you started</h2>

          <p>Enter your details below to create your account.</p>
        </div>

        <!-- Error -->
        @if (signupErrMsg) {
        <div class="signup-alert" role="alert">
          <div class="alert-icon">
            <i class="pi pi-exclamation-circle"></i>
          </div>
          <div class="alert-message">
            {{ signupErrMsg }}
          </div>
          <button
            type="button"
            class="alert-close"
            (click)="removeErrMsg()"
            aria-label="Close notification"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
        }

        <form [formGroup]="signupForm" class="signup-form">
          <!-- Row 1 -->
          <div class="form-row">
            <!-- First Name -->
            <div class="form-field">
              <label for="first_name">
                First Name
                <span>*</span>
              </label>

              <div class="input-wrapper">
                <i class="pi pi-user input-icon"></i>

                <input
                  id="first_name"
                  type="text"
                  class="form-input"
                  placeholder="Enter first name"
                  autocomplete="given-name"
                  formControlName="first_name"
                />
              </div>

              <form-validation [control]="signupForm.controls.first_name">
              </form-validation>
            </div>

            <!-- Last Name -->
            <div class="form-field">
              <label for="last_name"> Last Name </label>

              <div class="input-wrapper">
                <i class="pi pi-user input-icon"></i>

                <input
                  id="last_name"
                  type="text"
                  class="form-input"
                  placeholder="Enter last name"
                  autocomplete="family-name"
                  formControlName="last_name"
                />
              </div>

              <form-validation [control]="signupForm.controls.last_name">
              </form-validation>
            </div>
          </div>

          <!-- Row 2 -->
          <div class="form-row">
            <!-- Company -->
            <div class="form-field">
              <label for="company_name">
                Company Name
                <span>*</span>
              </label>

              <div class="input-wrapper">
                <i class="pi pi-building input-icon"></i>

                <input
                  id="company_name"
                  type="text"
                  class="form-input"
                  placeholder="Enter company name"
                  autocomplete="organization"
                  formControlName="company_name"
                />
              </div>

              <form-validation [control]="signupForm.controls.company_name">
              </form-validation>
            </div>

            <!-- Location -->
            <div class="form-field">
              <label for="location"> Location </label>

              <div class="input-wrapper">
                <i class="pi pi-map-marker input-icon"></i>

                <input
                  id="location"
                  type="text"
                  class="form-input"
                  placeholder="Enter location"
                  formControlName="location"
                />
              </div>

              <form-validation [control]="signupForm.controls.location">
              </form-validation>
            </div>
          </div>

          <!-- Row 3 -->
          <div class="form-row">
            <!-- Email -->
            <div class="form-field">
              <label for="email_id">
                Email Address
                <span>*</span>
              </label>

              <div class="input-wrapper">
                <i class="pi pi-envelope input-icon"></i>

                <input
                  id="email_id"
                  type="email"
                  class="form-input"
                  placeholder="name@company.com"
                  autocomplete="email"
                  formControlName="email_id"
                />
              </div>

              <form-validation [control]="signupForm.controls.email_id">
              </form-validation>
            </div>

            <!-- Phone -->
            <div class="form-field">
              <label for="phone_no">
                Contact Number
                <span>*</span>
              </label>

              <div class="input-wrapper">
                <i class="pi pi-phone input-icon"></i>

                <input
                  id="phone_no"
                  type="tel"
                  class="form-input"
                  placeholder="Enter contact number"
                  autocomplete="tel"
                  formControlName="phone_no"
                />
              </div>

              <form-validation [control]="signupForm.controls.phone_no">
              </form-validation>
            </div>
          </div>

          <!-- Signup Button -->
          @if (!showBtnSpinner) {
          <button
            type="button"
            class="signup-button"
            [disabled]="!signupForm.valid"
            (click)="createNewAcc(signupForm.value)"
          >
            <span>Create Account</span>
            <i class="pi pi-arrow-right"></i>
          </button>
          }

          <!-- Loading -->
          @if (showBtnSpinner) {
          <button type="button" class="signup-button loading" disabled>
            <span class="spinner-border"></span>
            <span>Creating account...</span>
          </button>
          }

          <!-- Login -->
          <div class="login-section">
            <span>Already have an account?</span>

            <a class="login-link" (click)="returnToLogin()"> Sign in </a>
          </div>

          <!-- Security -->
          <!-- <div class="signup-security">
            <i class="pi pi-lock"></i>

            <span> Your information is securely encrypted. </span>
          </div> -->
        </form>
      </div>
    </div>
  </div>
</div>
